import React, { Component } from 'react'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'
import Redactor from '~/Common-Objects/RedactorSwitch'
import clone from 'lodash/clone'
const ButtonLink = (props) => {
    const updateHtmlValue = (value) => {
        let newObject = clone(props.elementData)
        newObject.content.value = value
        props.updateElement(newObject, props.path)
    }

    let redactorEle = null
    let variant = 'primary'
    let eleProps

    if (props.elementData.props) {
        eleProps = DragDropFunctions.generatePropsForStage(
            props.elementData.props,
            props.globalVariables,
            'label',
            props.localVariables
        )
    }

    if (
        props.localVariables.linkNewTab &&
        (props.localVariables.linkNewTab.value === 'true' || props.localVariables.linkNewTab.value === true)
    ) {
        eleProps.target = '_blank'
    } else {
        eleProps.target = '_self'
    }

    let thisContent = props.elementData.content.value
    if (thisContent.indexOf('_localVariables_') >= 0)
        thisContent = DragDropFunctions.lookupLocalVariables(props.localVariables, thisContent)

    const elementData = props.elementData.props.data
    variant = DragDropFunctions.lookupLocalVariables(props.localVariables, elementData.variant.value)

    let buttonStyles = {
        backgroundColor: '#000',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 'normal',
        border: 'none',
        padding: '10px 20px',
        borderRadius: 8,
        textAlign: 'center',
        pointerEvens: 'none',
        display: 'inline-block'
    }

    switch (variant.toLowerCase()) {
        case 'primary':
            buttonStyles.backgroundColor = props.globalVariables.primaryButtonBgColor.value
            buttonStyles.color = props.globalVariables.primaryButtonFontColor.value
            buttonStyles.fontSize = props.globalVariables.primaryButtonFontSize.value
            buttonStyles.fontWeight = props.globalVariables.primaryButtonFontWeight.value
            buttonStyles.paddingTop = props.globalVariables.primaryButtonPaddingTop.value
            buttonStyles.paddingBottom = props.globalVariables.primaryButtonPaddingBottom.value
            buttonStyles.paddingLeft = props.globalVariables.primaryButtonPaddingLeft.value
            buttonStyles.paddingRight = props.globalVariables.primaryButtonPaddingRight.value
            buttonStyles.borderRadius = props.globalVariables.primaryButtonBorderRadius.value
            buttonStyles.borderColor = props.globalVariables.primaryButtonBorderColor.value
            buttonStyles.borderWidth = props.globalVariables.primaryButtonBorderWidth.value
            buttonStyles.borderStyle = props.globalVariables.primaryButtonBorderStyle.value
            break
        case 'secondary':
            buttonStyles.backgroundColor = props.globalVariables.secondaryButtonBgColor.value
            buttonStyles.color = props.globalVariables.secondaryButtonFontColor.value
            buttonStyles.fontSize = props.globalVariables.secondaryButtonFontSize.value
            buttonStyles.fontWeight = props.globalVariables.secondaryButtonFontWeight.value
            buttonStyles.paddingTop = props.globalVariables.secondaryButtonPaddingTop.value
            buttonStyles.paddingBottom = props.globalVariables.secondaryButtonPaddingBottom.value
            buttonStyles.paddingLeft = props.globalVariables.secondaryButtonPaddingLeft.value
            buttonStyles.paddingRight = props.globalVariables.secondaryButtonPaddingRight.value
            buttonStyles.borderRadius = props.globalVariables.secondaryButtonBorderRadius.value
            buttonStyles.borderColor = props.globalVariables.secondaryButtonBorderColor.value
            buttonStyles.borderWidth = props.globalVariables.secondaryButtonBorderWidth.value
            buttonStyles.borderStyle = props.globalVariables.secondaryButtonBorderStyle.value
            break
        case 'tertiary':
            buttonStyles.backgroundColor = props.globalVariables.tertiaryButtonBgColor.value
            buttonStyles.color = props.globalVariables.tertiaryButtonFontColor.value
            buttonStyles.fontSize = props.globalVariables.tertiaryButtonFontSize.value
            buttonStyles.fontWeight = props.globalVariables.tertiaryButtonFontWeight.value
            buttonStyles.paddingTop = props.globalVariables.tertiaryButtonPaddingTop.value
            buttonStyles.paddingBottom = props.globalVariables.tertiaryButtonPaddingBottom.value
            buttonStyles.paddingLeft = props.globalVariables.tertiaryButtonPaddingLeft.value
            buttonStyles.paddingRight = props.globalVariables.tertiaryButtonPaddingRight.value
            buttonStyles.borderRadius = props.globalVariables.tertiaryButtonBorderRadius.value
            buttonStyles.borderColor = props.globalVariables.tertiaryButtonBorderColor.value
            buttonStyles.borderWidth = props.globalVariables.tertiaryButtonBorderWidth.value
            buttonStyles.borderStyle = props.globalVariables.tertiaryButtonBorderStyle.value
            break
        case 'custom':
            buttonStyles.backgroundColor = props.localVariables.customButtonBgColor.value
            buttonStyles.color = props.localVariables.customButtonFontColor.value
            buttonStyles.fontSize = props.localVariables.customButtonFontSize.value
            buttonStyles.fontWeight = props.localVariables.customButtonFontWeight.value
            buttonStyles.paddingTop = props.localVariables.customButtonPaddingTop.value
            buttonStyles.paddingBottom = props.localVariables.customButtonPaddingBottom.value
            buttonStyles.paddingLeft = props.localVariables.customButtonPaddingLeft.value
            buttonStyles.paddingRight = props.localVariables.customButtonPaddingRight.value
            buttonStyles.borderRadius = props.localVariables.customButtonBorderRadius.value
            buttonStyles.borderColor = props.localVariables.customButtonBorderColor.value
            buttonStyles.borderWidth = props.localVariables.customButtonBorderWidth.value
            buttonStyles.borderStyle = props.localVariables.customButtonBorderStyle.value
            break
    }

    eleProps.style = { ...eleProps.style, ...buttonStyles }

    const isSelected = props.selectedElement.path === props.currentParentPath
    if (isSelected) {
        const elementUuid = props?.tuuid?.tuuid || ''
        const favoriteColors = props.globalVariables.favoriteColors || []
        const color = eleProps.style.color || ''
        redactorEle = (
            <Redactor
                content={thisContent}
                updateContent={updateHtmlValue}
                defaultFont={eleProps.style.fontFamily || ''}
                defaultColor={color || ''}
                globalColours={[]}
                favoriteColors={favoriteColors}
                elementsData={props.elementsData}
                elementUuid={elementUuid}
                overrideTools={['bold', 'italic', 'underline']}
                allowParagraphs={false}
                noOuterDiv={true}
                overridePlugins={[]}
            />
        )
    }

    return (
        <div {...eleProps}>
            {isSelected && redactorEle}
            {!isSelected && props.elementData.content.value && (
                <div dangerouslySetInnerHTML={{ __html: thisContent }}></div>
            )}
            {!isSelected && !props.elementData.content.value && <div>{props.children}</div>}
        </div>
    )
}

export default ButtonLink
